import React from "react";
import InlineSvg from "react-inlinesvg";
import usePublicMode from "../../hooks/usePublicMode";

const AssetSvg = (props) => {
  const { isPublicPluginsMode } = usePublicMode();
  let { src, ...otherProps } = props;

  if (isPublicPluginsMode) {
    src = `/plugins/assets/${src}`;
  } else {
    src = `/assets/${src}`;
  }

  return <InlineSvg src={src} {...otherProps} />;
};

export default AssetSvg;
